<template>
    <div class="home">
        <h1>Print Certificate</h1>
        <b-row>
            <b-col cols="12" v-if="hasComplaints == null">
                Please wait while system determines eligibility to print certificate.
            </b-col>
            <b-col cols="12" v-if="hasComplaints != null && !hasComplaints">
                <PrintCertificateButton></PrintCertificateButton>
            </b-col>
            <b-col cols="12" v-if="hasComplaints != null && hasComplaints">
                CNAs with substantiated complaints may not print a certificate.
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import PrintCertificateButton from "@/components/templates/display/PrintCertificateButton";
    import axios from 'axios';

    export default {
        name: "PrintCertificate",
        components: {
            PrintCertificateButton,
        },
        data: () => ({
            hasComplaints: null
        }),
        created() {
            document.title = 'Print Certificate';
            this.initialize()
        },
        methods: {
            initialize() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/certificate/complaints`)
                    .then(response => {
                        this.hasComplaints = response.data
                    })
            }
        }
    }


</script>

<style scoped>

</style>